<template>
  <PageDynamic path="/contact-us" :title="pageTitle" :description="pageDescription">
    <h1 class="sr-only">Contact Us</h1>
    <section class="section section--no-banner bg-black" >
      <div class="section__content bg-black">
        <div class="container">
          <div class="row">
            <div class="col-lg-7">
              <div class="content-wrapper">
                <div class="heading-wrapper text-white">
                  <div class="h2 heading-hightlight">LET'S GET</div>
                  <div class="h2 heading">A DEMO!</div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-10">
                  <div class="content-wrapper">
                    <div class="information">
                      <div class="information__wrapper">
                        <div class="information__title">
                          {{ translate("location") }}
                        </div>
                        <div class="information__detail">
                          {{ translate("address.detail01") }} <br />
                          {{ translate("address.detail02") }} <br />
                          {{ translate("address.detail03") }} <br />
                          {{ translate("address.detail04") }}
                        </div>
                        <div class="information__link">
                          <a class="btn btn--text-white" href="https://maps.app.goo.gl/Vp9YhtSNEz7LeewM9" target="_blank">
                            <span class="btn__title">{{
                              translate("get.direction")
                            }}</span>
                            <span class="btn__icon btn__icon--right"
                              ><i class="icon-arrow-button"></i
                            ></span>
                          </a>
                        </div>
                      </div>
                      <div class="information__wrapper">
                        <div class="information__title">
                          {{ translate("office.hour") }}
                        </div>
                        <div class="information__detail">
                          {{ translate("office.hour.detail01")
                          }}{{ translate("office.hour.detail02") }}
                        </div>
                      </div>
                      <div class="information__wrapper">
                        <div class="information__title">
                          {{ translate("email") }}
                        </div>
                        <div class="information__detail">
                          {{ translate("email.sale") }}
                        </div>
                      </div>
                      <div
                        class="information__wrapper information__wrapper--row"
                      >
                        <div class="information__group">
                          <div class="information__title">
                            {{ translate("tel") }}
                          </div>
                          <div class="information__detail">
                            {{ translate("tel.number") }}
                          </div>
                        </div>
                        <div class="information__group">
                          <div class="information__title">
                            {{ translate("fax") }}
                          </div>
                          <div class="information__detail">
                            {{ translate("fax.number") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="form-title-wrapper small">
                {{ translate("required.to") }}
              </div>
              <form
                class="form"
                method="post"
                @submit.prevent="submitForm($event)"
                id="formContact"
                enctype="multipart/form-data"
              >
                <Modal
                  v-model="showModal"
                  :title="formTitle"
                  :status="formSuccess"
                  :message="formMessage"
                  @close="resetModal"
                />

                <div class="form-group mt-0">
                  <div class="custom-radio">
                    <div class="custom-radio__list">
                      <input
                        type="radio"
                        id="wd"
                        name="service_category"
                        value="Corporate Website"
                         :checked="selectedCategory === 'wd'"
                         required
                      />
                      <label for="wd">Corporate Website</label>
                    </div>
                    <div class="custom-radio__list">
                      <input
                        type="radio"
                        id="ir"
                        name="service_category"
                        value="Online Investor Relations"
                        :checked="selectedCategory === 'ir'"
                      />
                      <label for="ir">Online Investor Relations</label>
                    </div>
                    <div class="custom-radio__list">
                      <input
                        type="radio"
                        id="communication-materials"
                        name="service_category"
                        value="Communication Materials"
                        :checked="selectedCategory === 'communication-materials'"
                      />
                      <label for="communication-materials"
                        >Communication Materials</label
                      >
                    </div>
                    <div class="custom-radio__list">
                      <input
                        type="radio"
                        id="seo-sem"
                        name="service_category"
                        value="SEO/SEM"
                        :checked="selectedCategory === 'seo-sem'"
                      />
                      <label for="seo-sem">SEO/SEM</label>
                    </div>
                    <div class="custom-radio__list">
                      <input
                        type="radio"
                        id="cyber-security"
                        name="service_category"
                        value="Cyber Security"
                        :checked="selectedCategory === 'cyber-security'"
                      />
                      <label for="cyber-security">Cyber Security</label>
                    </div>
                    <div class="custom-radio__list">
                      <input
                        type="radio"
                        id="esg-microsite"
                        name="service_category"
                        value="ESG Microsite"
                         :checked="selectedCategory === 'esg-microsite'"
                      />
                      <label for="esg-microsite">ESG Microsite</label>
                    </div>
                    <div class="custom-radio__list">
                      <input
                        type="radio"
                        id="executive-talk"
                        name="service_category"
                        value="Executive Talk"
                         :checked="selectedCategory === 'executive-talk'"
                      />
                      <label for="executive-talk">Executive Talk</label>
                    </div>
                    <div class="custom-radio__list">
                      <input
                        type="radio"
                        id="others"
                        name="service_category"
                        value="Others"
                         :checked="selectedCategory === 'others'"
                      />
                      <label for="others">Others</label>
                    </div>
                    
                  </div>
                </div>

                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    name="fullname"
                    :placeholder="translate('form.fullname')"
                    required
                  />
                </div>

                <div class="form-group">
                  <input
                    type="email"
                    class="form-control"
                    name="email"
                    :placeholder="translate('form.email')"
                    required
                  />
                </div>

                <div class="form-group">
                  <input
                    type="tel"
                    class="form-control"
                    name="phone"
                    :placeholder="translate('form.phone')"
                    required
                  />
                </div>

                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input
                      class="custom-control-input"
                      type="checkbox"
                      name="privacyStatement"
                      v-model="privacyStatement"
                    /><label
                      class="custom-control-label"
                      v-html="translate('privacy.statement.text')"
                    ></label>
                  </div>
                </div>
                <div class="form-group form-group--btn">
                  <span v-if="isLoading">
                    <button
                      :disabled="!privacyStatement"
                      class="btn btn--primary-white"
                      ref="shinyButton"
                    >
                      <span class="btn__wrapper">
                        <span class="btn__title" v-text="LoadingTitle"></span>
                        <span class="btn__icon"
                          ><i class="icon-arrow-button"></i
                        ></span>
                      </span>
                    </button>

                    <br /><br />
                    <Loading />
                  </span>
                  <span v-else>
                    <button
                      :disabled="!privacyStatement"
                      class="btn btn--primary-white"
                      ref="shinyButton"
                    >
                      <span class="btn__wrapper">
                        <span class="btn__title">
                          {{ translate("submit") }}</span
                        >
                        <span class="btn__icon"
                          ><i class="icon-arrow-button"></i
                        ></span>
                      </span>
                    </button>
                  </span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </PageDynamic>
</template>

<script setup>
import { useShinyButton } from "@/composables/useShinyButton";
import { useFormContact } from "@/composables/useFormContact";
import { usePageContentStore } from "@/stores/pageContent";
import { useBreadcrumbSchema } from "~/composables/useBreadcrumbSchema";

import PageDynamic from "@/components/pages/Dynamic.vue";
import { useRoute } from 'vue-router';
import Modal from "@/components/helpers/Modal.vue";
import Loading from "@/components/helpers/Loading.vue";

const route = useRoute()
const selectedCategory = route.query.id // ดึงค่าพารามิเตอร์ id

const store = usePageContentStore();
const { public: { siteUrl } } = useRuntimeConfig();

// SSR-safe metadata fetch (same pattern as pages/home.vue) — same literal
// path used by fetchPageContent below, so the cache key matches and the
// client-only fetch (which also parses shortcodes) reuses this response
// instead of fetching again.
await store.fetchPageMeta('/contact-us');

const pageTitle = computed(() => store.title);
const pageDescription = computed(() => store.description);

const pageUrl = computed(() => `${siteUrl}${route.path}`);

useHead(() => {
  // Last crumb is always this page — index from the end so a future CMS
  // re-nesting under a parent can't silently swap in the ancestor's name.
  const crumbs = store.breadcrumbs;
  const pageName = crumbs[crumbs.length - 1]?.title?.trim() || "Contact Us";
  const breadcrumbItems = [
    { name: "Home", url: `${siteUrl}/` },
    { name: pageName, url: pageUrl.value },
  ];

  return {
    script: [
      {
        type: "application/ld+json",
        innerHTML: JSON.stringify(useBreadcrumbSchema(breadcrumbItems, pageUrl.value)),
      },
      {
        type: "application/ld+json",
        innerHTML: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ContactPage",
          "@id": `${pageUrl.value}#webpage`,
          url: pageUrl.value,
          name: pageName,
          about: { "@id": `${siteUrl}/#organization` },
        }),
      },
    ],
  };
});

// ใช้ Composable
const {
  isLoading,
  LoadingTitle,
  formSuccess,
  formTitle,
  formMessage,
  showModal,
  privacyStatement,
  submitForm,
  resetModal,
  translate,
} = useFormContact();

// ใช้ shinyButton
const { shinyButton } = useShinyButton();


const fetchPageContent = async () => {
  try {

    await store.fetchPageContent('/contact-us');

  } catch (error) {
    console.error("Error fetching page content:", error);
  }
};

onMounted(() => {
  fetchPageContent();
});


</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";

@each $lang in $languages {
  html[lang="#{$lang}"] {
    .heading-wrapper {
      .heading {
        line-height: 1;
      }

      .heading-hightlight {
        line-height: 1;
      }
    }

    .list-item {
      @include font-size("small", $lang);
      line-height: 2;
    }

    .section__headline {
      @include media-breakpoint-down(sm) {
        @include font-size("h6", $lang);
      }
    }

    .btn {
      &.btn--primary-white {
        .btn__title {
          @include font-size("body", $lang);
        }
      }
    }

    .information {
      @include font-size("small", $lang);

      .information__title {
        @include font-weight("bold", $lang);
      }
    }
  }
}

.content-wrapper {
  padding-right: 2rem;

  @include media-breakpoint-down(lg) {
    padding-right: 0rem;
  }
}

.heading-wrapper {
  width: fit-content;

  .heading {
    text-align: end;
    text-indent: 5rem;

    @include media-breakpoint-down(lg) {
      text-align: start;
    }
    @include media-breakpoint-down(sm) {
      text-indent: 2rem;
    }
  }
}

.form-title-wrapper {
  color: rgba($white, 0.5);
  margin: 5.125rem 0 0.75rem 0;
}

.section__img-wrapper {
  text-align: center;
  margin-top: 2.5rem;

  img {
    max-width: 95%;
    height: auto;
    border-radius: 170px;
  }
}

.btn {
  &.btn--primary-white {
    min-width: 177px;
    height: 62px;
    border-radius: 40px;

    .btn__title {
      text-transform: unset;
    }
  }
}

.information {
  margin-top: 2.125rem;
  padding-left: 3rem;

  .information__wrapper {
    margin-bottom: 1.875rem;

    &:last-child {
      margin-bottom: 0;
    }

    &.information__wrapper--row {
      display: flex;
      flex-direction: row;
      gap:150px;

      @include media-breakpoint-down(md) {
        flex-direction: column;
        gap:unset;

        .information__group {
          &:last-child {
            margin-top: 1.875rem;
          }
        }
      }
    }
  }

  .information__title {
    color: $yellow-ci;
    text-transform: uppercase;
  }

  .information__detail {
    color: $white;
  }

  .information__link {
    margin-top: 1rem;
    i {
      font-size: px-to-rem(9);
    }
  }

  @include media-breakpoint-down(md) {
    padding-left: 0rem;
  }
}
</style>